export default __webpack_public_path__ + "static/team-tariq@2x-bfc4fdab242b7a46cdbd3ff38e9c7cf4.png";